import { type ReactNode, useEffect, useState } from "react";

import { createHaNViewStore, HaNViewStoreContext, type HereAndNowTab } from "@lib/logic";

import { useHereAndNowData } from "../data/useHereAndNowData";
import { HaNErrorBoundary } from "../shared/HaNErrorBoundary";
import { haNSession } from "../state/session/haNSession";
import { HaNContext } from "./HaNContext";

type HaNPageProps = {
  tab: HereAndNowTab;
  children?: ReactNode;
};

export const HaNPage = ({ tab, children }: HaNPageProps) => {
  return (
    <div className="[grid-area:fullbody/fullbleed]">
      <HaNErrorBoundary
        area="Page"
        resetKeys={[tab]}>
        <HaNPageContent tab={tab}>{children}</HaNPageContent>
      </HaNErrorBoundary>
    </div>
  );
};

const HaNPageContent = ({ tab, children }: HaNPageProps) => {
  const data = useHereAndNowData(tab);
  const [viewStore] = useState(createHaNViewStore);

  // Every way onto a tab counts (tab bar, deep links, back button), so this follows the route instead of clicks
  useEffect(
    function rememberTab() {
      haNSession.rememberTab(tab);
    },
    [tab],
  );

  return (
    <HaNContext.Provider value={{ tab, ...data }}>
      <HaNViewStoreContext.Provider value={viewStore}>{children}</HaNViewStoreContext.Provider>
    </HaNContext.Provider>
  );
};
